import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

const CustomObjectsRelationshipViewScene = lazy(() =>
  import("@scenes/CustomObjects").then((module) => ({
    default: module.CustomObjectsRelationshipViewScene,
  }))
);

export const customObjectRelationshipViewNRO: NavigationRoutingObject = {
  Component: CustomObjectsRelationshipViewScene,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "data-settings",
  // The heading drives document.title, so the browser tab reads "View <api name>" for the
  // relationship opened from the Relationship settings table.
  heading: (t: I18nT<"dashboard-navigation">, { params }) =>
    t("view-relationship-nro-heading", "View { apiName }", { apiName: params.relKind ?? "" }),
  pageNameForTracking: () => "View Relationship",
  description: (t: I18nT<"dashboard-navigation">) =>
    t("view-relationship-nro-description", "View the definition and fields of a data object relationship"),
  icon: "nav-system-accounts",
  tag: "early-access",
  getDeveloperNavigationAllowed: ({ featureOn }) => {
    return (
      featureOn("accounts_nro_component") &&
      featureOn("b2b_ea") &&
      featureOn("custom_object_relationship_management")
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
  defaultRoute: "/dashboard/accounts/:appGroupId",
};
